import { createContext } from 'react';

export const LayoutCompanyContext = createContext({
  toggle: false,
  onToggle: () => null,
});
